export const SocialData = [
  {
    platform: "Instagram",
    link: "https://www.instagram.com/_deepakbarnwal/?hl=en",
    icon: require("../../assets/instagram.png"),
  },
  {
    platform: "Facebook",
    link: "https://www.facebook.com/deepak.barnwal.336333/",
    icon: require("../../assets/facebook.png"),
  },
  {
    platform: "LinkedIn",
    link: "https://www.linkedin.com/in/deepak-barnwal-216b48186/",
    icon: require("../../assets/linkedin.png"),
  },
  {
    platform: "Github",
    link: "https://github.com/dbarnwal",
    icon: require("../../assets/github.png"),
  },
];
